/* eslint-disable camelcase */
import { useQuery } from '@apollo/client';
import {T} from '../../../utils/I18n/I18n';
import {useTranslation} from "react-i18next";
import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { LATEST_NEWS } from '../newsQuery';
import './NewsSidebar.scss';

const NewsSidebar = () => {
  const { t } = useTranslation();
  const { data, error, loading } = useQuery(LATEST_NEWS);

  if (error) {
    console.log('Error: ', error.message);
    return <h2>Error occured while loading data.</h2>;
  }

  if (loading) {
    return null;
  }

  return (
    <div className="news-sidebar">
      <h3 className="news-sidebar__title">
        <T id="news.latestNewsPosts" />
      </h3>

      {data &&
        data.latestNews
          .filter(({ is_active }) => is_active)
          .map(({ title, url_key, newspost_id }) => (
            <ul key={newspost_id} className="news-sidebar__latest-news">
              {/* <hr /> */}
              <li>
                <Link key={title} to={`/${t('news.newsLink')}/${url_key}`}>
                  {title}
                </Link>
              </li>
            </ul>
          ))}
    </div>
  );
};

export default NewsSidebar;
